// extracted by mini-css-extract-plugin
module.exports = {"root":"BodyFormPermit_root__2cSeb","gridBox":"BodyFormPermit_gridBox__3v2Fk"};